import translationService from 'services/translation';

const TL = (key: string) => translationService.translate(key);

export default TL;
